<template>
  <div>
    <div class="border rounded-lg bg-white p-3 mb-4">
      <div class="flex flex-wrap items-end gap-3">
        <div v-if="state.isAllScope" class="text-sm text-gray-500">
          Select a university to view survey analytics.
        </div>
        <template v-else>
          <div>
            <label class="block text-xs text-gray-600 mb-1">Season</label>
            <select v-model="surveySeasonKeyProxy" class="border rounded px-3 py-2 min-w-[260px]" @change="actions.onSurveySeasonChange()">
              <option value="all">All ceremonies</option>
              <option v-for="s in state.surveySeasons" :key="s.key" :value="s.key">{{ s.label }}</option>
            </select>
          </div>
          <div class="relative" ref="surveyCeremonyDropdown">
            <label class="block text-xs text-gray-600 mb-1">Ceremonies in scope</label>
            <button
              type="button"
              class="border rounded px-3 py-2 min-w-[340px] text-left text-sm bg-white hover:bg-gray-50 flex items-center justify-between"
              @click.stop="actions.toggleSurveyCeremonyDropdown()"
            >
              <span class="truncate pr-2">{{ state.surveyCeremonySelectionLabel }}</span>
              <span class="text-xs text-gray-500">{{ state.surveyCeremonyDropdownOpen ? '▴' : '▾' }}</span>
            </button>
            <div
              v-if="state.surveyCeremonyDropdownOpen"
              class="absolute z-20 mt-1 w-[420px] max-w-[92vw] border rounded-lg bg-white shadow-lg p-3"
              @click.stop
            >
              <div class="flex items-center justify-between mb-2">
                <div class="text-xs text-gray-600">Select ceremonies</div>
                <div class="flex items-center gap-2">
                  <button type="button" class="text-xs text-blue-700 hover:underline" @click="actions.selectAllSurveyCeremonyDraft()">Select all</button>
                  <button type="button" class="text-xs text-blue-700 hover:underline" @click="actions.clearSurveyCeremonyDraft()">Clear</button>
                </div>
              </div>
              <div v-if="!state.surveyCeremonyOptionsForControl.length" class="text-xs text-gray-500 py-2">No ceremonies available for this season.</div>
              <div v-else class="max-h-56 overflow-auto border rounded p-2">
                <label
                  v-for="c in state.surveyCeremonyOptionsForControl"
                  :key="`survey-cer-dd-${c.id}`"
                  class="flex items-start gap-2 text-xs py-1 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    :checked="state.surveyCeremonySelectionDraft.includes(String(c.id))"
                    @change="actions.onSurveyCeremonyDraftChange(String(c.id), $event.target.checked)"
                  />
                  <span>{{ actions.formatSurveyCeremonyOption(c) }}</span>
                </label>
              </div>
              <div class="flex items-center justify-between mt-3">
                <div class="text-xs text-gray-500">{{ state.surveyCeremonySelectionDraft.length }} selected</div>
                <div class="flex items-center gap-2">
                  <button type="button" class="px-2 py-1 border rounded text-xs hover:bg-gray-50" @click="actions.closeSurveyCeremonyDropdown()">Cancel</button>
                  <button type="button" class="px-2 py-1 border rounded text-xs bg-black text-white border-black" @click="actions.applySurveyCeremonySelection()">Apply</button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button @click="actions.loadSurvey()" class="bg-black text-white px-3 py-2 rounded text-xs">Refresh</button>
          </div>
          <!-- <div class="flex items-center gap-2">
            <button
              type="button"
              class="px-3 py-2 rounded text-xs border bg-white hover:bg-gray-50"
              title="Export survey data for the currently selected season and ceremonies. Coming soon."
              @click="onExportDataClick"
            >
              EXPORT DATA
            </button>
            <span
              class="text-gray-400 cursor-help text-xs info-tip"
              title="Exports all survey analytics rows for the current scope. This button is a placeholder for now."
              role="img"
              aria-label="Export data help"
            >
              ⓘ
            </span>
          </div> -->
        </template>
      </div>
    </div>
    <div v-if="!state.isAllScope" class="text-xs text-gray-500 mb-3">
      Survey metrics are cohort-based and scoped to the selected ceremonies (not rolling engagement windows).
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyScopeControlsSection',
  props: {
    state: { type: Object, required: true },
    actions: { type: Object, required: true },
  },
  methods: {
    onExportDataClick() {
      // Placeholder action until export wiring is implemented.
    },
  },
  computed: {
    surveySeasonKeyProxy: {
      get() { return this.state.surveySeasonKey },
      set(value) { this.$emit('update:surveySeasonKey', value) },
    },
  },
}
</script>
